import React from 'react';
import { NavLink } from 'react-router-dom';
import BranchSwitcher from './BranchSwitcher';
import './Sidebar.css';
import Logo from '../../brand/Logo';
import { getStoredUser } from '../../utils/auth';
import { canEditOrders, canSeeCosts, getRoleLabel } from '../../utils/roles';
import Icon from '../common/Icon';

const Sidebar = ({ isOpen, onClose, role }) => {
    const userRole = String(role || '').toLowerCase();
    const isMaster = userRole === 'master';
    const isManager = userRole === 'manager';
    const isAdmin = userRole === 'admin';
    const canSeeOffice = canSeeCosts(userRole);
    const currentUser = getStoredUser();

    const handleNavClick = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <div className={`sidebar${isOpen ? ' open' : ''}`}>
            <div className="sidebar-header">
                <Logo variant="full" size={44} className="sidebar-logo" />
                <button
                    type="button"
                    className="sidebar-close"
                    onClick={onClose}
                    aria-label="Закрыть меню"
                >
                    <Icon name="times" />
                </button>
            </div>

            {isAdmin && <BranchSwitcher />}

            <nav className="sidebar-nav">
                <ul className="sidebar-menu">
                    <li>
                        <NavLink
                            exact
                            to={{ pathname: '/dashboard', state: { fromMenu: true } }}
                            activeClassName="active"
                            onClick={handleNavClick}
                        >
                            <Icon name="tachometer-alt" />
                            <span>{isMaster ? 'Календарь' : 'Панель управления'}</span>
                        </NavLink>
                    </li>
                    {isMaster && (
                        <li>
                            <NavLink exact to="/my-day" activeClassName="active" onClick={handleNavClick}>
                                <Icon name="calendar-day" />
                                <span>Мой день</span>
                            </NavLink>
                        </li>
                    )}

                    {/* Основной функционал */}
                    <li className="sidebar-divider">
                        <span>Основное</span>
                    </li>

                    {canEditOrders(userRole) && (
                        <li>
                            <NavLink to="/orders/new" activeClassName="active" onClick={handleNavClick}>
                                <Icon name="plus-circle" />
                                <span>Новый заказ</span>
                            </NavLink>
                        </li>
                    )}
                    <li>
                        <NavLink to="/orders" activeClassName="active" onClick={handleNavClick}>
                            <Icon name="clipboard-list" />
                            <span>Заказы</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/orders/completed" activeClassName="active" onClick={handleNavClick}>
                            <Icon name="check-circle" />
                            <span>Завершенные</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/services" activeClassName="active" onClick={handleNavClick}>
                            <Icon name="concierge-bell" />
                            <span>Услуги</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/clients" activeClassName="active" onClick={handleNavClick}>
                            <Icon name="users" />
                            <span>Клиенты</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/vehicles" activeClassName="active" onClick={handleNavClick}>
                            <Icon name="car" />
                            <span>Автомобили</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/dealerships" activeClassName="active" onClick={handleNavClick}>
                            <Icon name="building" />
                            <span>Автосалоны</span>
                        </NavLink>
                    </li>

                    {/* Новые функции */}
                    <li className="sidebar-divider">
                        <span>Аналитика и операции</span>
                    </li>

                    {canSeeOffice && (
                        <li>
                            <NavLink to="/analytics" activeClassName="active" onClick={handleNavClick}>
                                <Icon name="chart-bar" />
                                <span>Аналитика и отчёты</span>
                            </NavLink>
                        </li>
                    )}
                    {canSeeOffice && (
                        <li>
                            <NavLink to="/accounting" activeClassName="active" onClick={handleNavClick}>
                                <Icon name="calculator" />
                                <span>Бухгалтерия</span>
                            </NavLink>
                        </li>
                    )}
                    {canSeeOffice && (
                        <li>
                            <NavLink to="/accounting/expenses" activeClassName="active" onClick={handleNavClick}>
                                <Icon name="receipt" />
                                <span>Расходы по категориям</span>
                            </NavLink>
                        </li>
                    )}
                    {canSeeOffice && (
                        <li>
                            <NavLink to="/schedule" activeClassName="active" onClick={handleNavClick}>
                                <Icon name="calendar-alt" />
                                <span>Расписание мастеров</span>
                            </NavLink>
                        </li>
                    )}
                    <li>
                        <NavLink to="/materials" activeClassName="active" onClick={handleNavClick}>
                            <Icon name="box" />
                            <span>Материалы</span>
                        </NavLink>
                    </li>

                    {canSeeOffice && (
                        <>
                            {/* Администрирование */}
                            <li className="sidebar-divider">
                                <span>Администрирование</span>
                            </li>

                            {!isManager && (
                                <li>
                                    <NavLink to="/users" activeClassName="active" onClick={handleNavClick}>
                                        <Icon name="user-cog" />
                                        <span>Пользователи</span>
                                    </NavLink>
                                </li>
                            )}
                            <li>
                                <NavLink to="/settings/currency-rates" activeClassName="active" onClick={handleNavClick}>
                                    <Icon name="exchange-alt" />
                                    <span>Курсы валют</span>
                                </NavLink>
                            </li>
                        </>
                    )}
                    <li className="sidebar-divider">
                        <span>Настройки устройства</span>
                    </li>
                    <li>
                        <NavLink to="/settings/notifications" activeClassName="active" onClick={handleNavClick}>
                            <Icon name="bell" />
                            <span>Уведомления</span>
                        </NavLink>
                    </li>
                </ul>
            </nav>

            {currentUser && (
                <div className="sidebar-user">
                    <div className="sidebar-user-name">{currentUser.full_name || currentUser.username}</div>
                    <div className="sidebar-user-role">{getRoleLabel(userRole)}</div>
                </div>
            )}
        </div>
    );
};

export default Sidebar;